import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { AnalyticsEvent, AnalyticsService } from '../../core/services/analytics-service';
import { ApiService } from '../../core/services/api.service';
import { AppConfig } from '../../core/services/app-config.service';
import { DialogService } from '../../core/services/dialog.service';
import { Liability } from '../../liabilities/models/liability.model';
import { XsellConsentDialogComponent } from '../components/xsell-consent-dialog/xsell-consent-dialog.component';
import {
  XsellConsentUnavailableDialogComponent,
} from '../components/xsell-consent-unavailable-dialog/xsell-consent-unavailable-dialog.component';
import { CustomerBiller } from '../models/model';
import { WIDTH_500 } from '../../shared/configs/dialog-config';

@Injectable({
  providedIn: 'root',
})
export class XsellService {
  constructor(
    private appConfig: AppConfig,
    private analyticsService: AnalyticsService,
    private apiService: ApiService,
    private router: Router,
    private dialogService: DialogService,
  ) {
  }

  public xsellOfferVisibleForCustomerBiller(customerBiller: CustomerBiller): boolean {
    return this.appConfig.config.xsell.enabled && customerBiller.showXsellConsentBtn;
  }

  public xsellOfferVisibleForLiability(liability: Liability): boolean {
    return this.appConfig.config.xsell.enabled && liability.showXsellConsentBtn;
  }

  public showXsellConsentAdditionalInfo(customerBillerId: string, route: ActivatedRoute, eventSource: string): Observable<any> {
    this.analyticsService.trackEvent(new AnalyticsEvent('Find better offer', eventSource));

    if (!customerBillerId) {
      return of(this.dialogService.open(XsellConsentUnavailableDialogComponent, { maxWidth: WIDTH_500 }));
    }

    return this.apiService.get<CustomerBiller>(`/customerBillers/${customerBillerId}`).pipe(
      switchMap((customerBiller) =>
        this.dialogService
          .open(XsellConsentDialogComponent, {
            data: customerBiller,
            maxWidth: WIDTH_500,
          })
          .afterClosed()
          .pipe(
            tap((result) => {
              if (!!result) {
                this.router.navigate(['/billers/xsell-consent-additional-info'], {
                  queryParams: { customerBillerId },
                  relativeTo: route,
                });
              }
            }),
          ),
      ),
    );
  }
}
